import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

export function useCanonicalCourseUrl(course, { playlist = false } = {}) {
  const navigate = useNavigate();
  const location = useLocation();
  const courseId = course?.id;
  const courseTitle = course?.title;

  useEffect(() => {
    if (!courseId || !String(courseTitle || '').trim()) return;

    const courseRef = { id: courseId, title: courseTitle };
    const canonicalPath = playlist
      ? ROUTES.COURSE_PLAYLIST(courseRef)
      : ROUTES.COURSE_DETAIL(courseRef);

    if (location.pathname === canonicalPath) return;

    navigate(`${canonicalPath}${location.search}${location.hash}`, { replace: true });
  }, [courseId, courseTitle, playlist, navigate, location.pathname, location.search, location.hash]);
}
